// extracted by mini-css-extract-plugin
export default {"no-preview":"no-preview_no-preview__0FUEJ"};